import React from 'react';
import SweetAlertsContainer from '../../Componant/Bonus-Ui/SweetAlert';

const SweetAlerts = () => {
  return (
    <div className='page-body'>
      <SweetAlertsContainer />
    </div>
  );
};

export default SweetAlerts;
